import { isNullOrUndefined, isPositiveNumber } from "et3-type-guards";
import { ReactNode } from "react";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import SenderIcon from "./SenderIcon";
import IsSeenTick from "./IsSeenTick";
import MessageBody from "./MessageBody";
import CreatedOn from "./MessageDate";
import { TGender } from "../../../../../../../Types";

const Message = withLiteObserverAndTheme<{
  isKhattabaMessage: boolean;
  isLastInSubGroup: boolean;
  isClientMessage: boolean;
  message: string;
  messageType: string;
  createdOn: string;
  isSeen: boolean;
  senderGender: TGender;
  // Generic content slot rendered inside the bubble, below the existing
  // text/tick/date row. Kept as a plain ReactNode (not a 102-specific type)
  // so this shared component - used by 101C/101M/Comments too - stays
  // unaware of the 102 reaction DTO; it renders nothing extra when omitted.
  reactionsSlot?: ReactNode;
  // Generic content slot rendered outside the bubble, beside it. Same
  // rationale as reactionsSlot: kept as a plain ReactNode so this shared
  // component stays unaware of the 102 hidden-message DTO.
  hiddenIndicatorSlot?: ReactNode;
}>((props) => {
  const {
    theme,
    isKhattabaMessage,
    isLastInSubGroup,
    isClientMessage,
    message,
    createdOn,
    isSeen,
    messageType,
    senderGender,
    reactionsSlot,
    hiddenIndicatorSlot
  } = props;
  const { colors, unitX } = theme;
  const backgroundColor = isKhattabaMessage
    ? colors.all.paleBluishGray
    : senderGender === "m"
      ? colors.all.bondiBlue
      : colors.all.vibrantPinkishMagenta;
  const isSeenMessage = isPositiveNumber(isSeen);

  return (
    <ET3Div
      width={1188}
      height={0}
      alignItems={"center"}
      fDirection={"row"}
      color={colors.all.transparent}
      justifyContent={isKhattabaMessage ? "flex-end" : "flex-start"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => { }}
      style={{}}
    >
      <Et3Margin left={10} right={5} top={0} bottom={0} />

      <SenderIcon
        isLastInSubGroup={isLastInSubGroup}
        isKhattabaMessage={isKhattabaMessage}
        isClientMessage={isClientMessage}
        senderGender={senderGender}
      />

      <Et3Margin left={0} right={10} top={0} bottom={0} />

      <ET3Div
        width={0}
        height={0}
        alignItems={"flex-start"}
        fDirection={"column"}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => { }}
        style={{
          backgroundColor,
          borderRadius: 20 * unitX,
          borderBottomRightRadius: isKhattabaMessage ? 0 : 20 * unitX,
          borderBottomLeftRadius: !isKhattabaMessage ? 0 : 20 * unitX,
          width: "auto",
          overflow: "hidden",
          maxWidth: 834 * unitX
        }}
      >
        <ET3Div
          width={0}
          height={0}
          alignItems={"flex-end"}
          fDirection={"row"}
          color={""}
          justifyContent={"flex-start"}
          withShadow={false}
          isExtendable={true}
          isScrollable={false}
          onClick={() => { }}
          style={{ width: "auto" }}
        >
          <Et3Margin top={0} bottom={0} left={10} right={10} />

          <MessageBody
            message={message}
            messageType={messageType}
            isKhattabaMessage={isKhattabaMessage}
          />

          <Et3Margin top={0} bottom={0} left={10} right={10} />

          <IsSeenTick
            isSeenMessage={isSeenMessage}
            isKhattabaMessage={isKhattabaMessage}
          />

          <CreatedOn
            createdOn={createdOn}
            isKhattabaMessage={isKhattabaMessage}
          />

          <Et3Margin top={0} bottom={0} left={2} right={2} />
        </ET3Div>
        {reactionsSlot == null ? null : (
          <ET3Div
            width={0}
            height={0}
            alignItems={"center"}
            fDirection={"row"}
            color={""}
            justifyContent={"flex-start"}
            withShadow={false}
            isExtendable={true}
            isScrollable={false}
            onClick={() => { }}
            style={{ width: "auto" }}
          >
            <Et3Margin top={0} bottom={6} left={10} right={0} />
            {reactionsSlot}
          </ET3Div>
        )}
      </ET3Div>
      {isNullOrUndefined(hiddenIndicatorSlot) ? null : (
        <>
          <Et3Margin left={10} right={0} top={0} bottom={0} />
          {hiddenIndicatorSlot}
        </>
      )}
      <Et3Margin left={20} right={20} top={0} bottom={0} />
    </ET3Div>
  );
});

export default Message;
